import { render, staticRenderFns } from "./NewBudgetModal.vue?vue&type=template&id=a0babe72&"
import script from "./NewBudgetModal.vue?vue&type=script&lang=js&"
export * from "./NewBudgetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewBudgetModal.vue"
export default component.exports